// components/filters/TotalOOFilter.js
import React from "react";
import FilterBase from "../FilterBase";
import Input from "../../ui/Input";
import Space from "../../ui/Space";
import { FILTER } from "../../utils/Struct";
import Button from "../../ui/Button";
import DateField from "../../ui/DateField";
import { bm_date } from "../../utils/Utils";
import { ENUMS } from "../../utils/Enums";
import { drawPicker } from "../../popovers/Picker";
import { ROUTES } from "../../utils/Routes";
import SelectBox from "../../ui/SelectBox";

export default function ConditionOnly(props) {

    const { controller = "", onSave = () => { }, onClose = () => { }, filter = {}, date = false, edit = false, inputParams = { number: true, maxLength: 3, width: 35 } } = props;

    const route = ROUTES.REPORTS.FILTER_EDIT;
    const { value = 1, text = "", text2 = "" } = filter;

    
    const fields = [
        { key: "comparison", value: "=", help: "= equal, < less, > greater  (PgUp to select)" },
        { include: true, label: "save", key: "save", value: "", help: "Press Enter to save" },
    ];

    const save = (tabs) => {
        const comparison = tabs.find(f => f.key === "comparison").value;
      
        const _f = {
            ...FILTER,
            type: value,
            comparison: comparison,
        }
        onSave(_f);
    }




    return (
        <FilterBase controller={controller} fields={fields} onClose={() => onClose()} onSave={(tabs) => {
            save(tabs)
        }}>
            {({ editProps, update, tabs, proceed, refs, index }) => (
                <div>
                    <Space>
                        <span>{text}</span>
                         <SelectBox
                         width={110}
                            {...editProps("comparison")}
                            options={[
                                { value: "=", label: "Equal to" },
                                { value: "<", label: "Less than"},
                                { value: ">", label: "Greater than"},
                            ]}
                        />
                        {(text2 && <span>{text2}</span>)}
                        <Button onClick={() => save(tabs)} {...editProps("save")} >Save</Button>
                        
                    </Space>
                </div>
            )}
        </FilterBase>
    );
}
